import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';
import { TutorialCreationRequest } from '@/modules/infodayco/shared/domain/tutorial-creation-request';
import { GuideFile } from '@/modules/infodayco/shared/domain/guide-file';
import { GuideView } from '@/modules/infodayco/shared/domain/guide.view';
import { FileCreationRequest } from '@/modules/infodayco/shared/domain/file-creation.request';

class ServiceModels extends HttpRepository {
    private static readonly RESOURCE = 'service-model';
    async getAll(): Promise<GuideView> {
        return (
            await this.get(
                this.createUri([ServiceModels.RESOURCE]),
                this.createAuthorizationHeader(),
            )
        ).data;
    }

    getServiceModels(guide: GuideFile) {
        return this.get(
            this.createUri([`${ServiceModels.RESOURCE}/${guide.id}`]),
            this.createAuthorizationDocumentsHeader(),
        );
    }

    deleteServiceModel(guide: GuideFile) {
        return this.delete(
            this.createUri([`${ServiceModels.RESOURCE}/${guide.id}`]),
            this.createAuthorizationHeader(),
        );
    }

    async uploadServiceModel(request: FileCreationRequest): Promise<GuideFile> {
        const formData = new FormData();
        formData.set('file', request.file, request.file.name);
        formData.append('name', request.name);
        return (
            await this.post(`${ServiceModels.RESOURCE}`, formData, this.createAuthorizationHeader())
        ).data;
    }
}
const serviceModelRepository = new ServiceModels();
export default serviceModelRepository;
